import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function ReportesAgenda() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        axios.get('/get-client', {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        })
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="reports" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                        <li className="breadcrumb-item active">Reportes de Agenda</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Reportes de Agenda</h1>
                                        <p className="dash-subtitle mb-0">Estadísticas y búsqueda de citas</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right d-flex flex-wrap justify-content-md-end" style={{ gap: '8px' }}>
                                    <Link to="/estadisticas" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver
                                    </Link>
                                    <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-home mr-1"></i> Inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-calendar-check"></i></span>
                                        Agenda
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/estadisticas-agenda" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-chart-pie"></i></div>
                                            <p className="quick-title">Estadísticas de Agenda</p>
                                            <p className="quick-sub">Gráficos y resumen de citas</p>
                                        </Link>

                                        <Link to="/busqueda-citas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-search"></i></div>
                                            <p className="quick-title">Reporte de Citas</p>
                                            <p className="quick-sub">Búsqueda y exportación</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ReportesAgenda;
